export default {
  blank: () => import("/code/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/code/layouts/default.vue").then(m => m.default || m)
}